import {Controller} from '@stubhub/react-store-provider';

import {
  deviceSelector,
  faceValueSelector,
  hideEstimatedFeeSelector,
  preSelectIncludeFeesSelector,
  showFaceValueSelector,
  showLegalSelector,
  showNonOfficialSelector,
  showPriceIncludeVATSelector,
  showPriceSetBySellerSelector,
  showPriceVaryFaceValueSelector,
  showTrustMessagesSelector,
} from './selectors';

const NAMESPACE = 'event';

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state) {
    return {
      faceValue: faceValueSelector(state),
      showTrustMessages: showTrustMessagesSelector(state),
      showLegal: showLegalSelector(state),
      device: deviceSelector(state),
      showPriceSetBySeller: showPriceSetBySellerSelector(state),
      showPriceVaryFaceValue: showPriceVaryFaceValueSelector(state),
      showFaceValue: showFaceValueSelector(state),
      preSelectIncludeFees: preSelectIncludeFeesSelector(state),
      hideEstimatedFee: hideEstimatedFeeSelector(state),
      showPriceIncludeVAT: showPriceIncludeVATSelector(state),
      showNonOfficial: showNonOfficialSelector(state),
    };
  },
});

export default controller;
